import { RequestRoot } from "types";
import { InfoSiteRequest } from "./info-site-request";

export class SubscriptionUpdateResult {
    constructor(
        public request: RequestRoot,
        public info: InfoSiteRequest,
        public notified: boolean
    ) { }
}
